import { CadType, ObjectItemType } from 'webstudio/src/client/project_content_types';
import { URL } from '_data/types/base';

export enum EScannerKind {
  UnknownExplicit = 'Unknown', // regersses unknown type
  Unknown = '', // - Unknown scanner type (util will choose scanner type)
  Small = 'Small', // - Artec S scanner
  WallyL = 'WallyL', // - Artec M, MH and MHT scanners
  WallyP = 'WallyP', // - Artec M, MH and MHT scanners
  Eva = 'Eva', // - Artec Eva scanner
  LargeP = 'LargeP', // - Artec L scanner
  LargeL = 'LargeL', // - Artec L scanner
  Spider = 'Spider', // - Artec Spider scanner
  LargeG = 'LargeG', // - Artec L2 scanner
  Leo = 'Leo', // - Artec Leo scanner
  Micro = 'Micro', // - Artec Micro scanner
  Ray = 'Ray', // Artec Ray scanner
  Ray2 = 'Ray2', // Artec Ray II scanner
}

interface IWSObjectBase {
  id: string;
  name: string;
  type: ObjectItemType;
  visible: boolean;
}

export interface I3dObjectBrief extends Omit<IWSObjectBase, 'type' | 'visible'> {
  object_type: ObjectItemType;
  cad_type?: CadType;
  scanner_type?: EScannerKind;
  preview_presigned_url?: URL;
}
